import { Component } from 'opus-angular-seed-core';
import animationData from '../../loader/icon/animation.json';

@Component({
    template: `
        <style>
            .ai-copilot-button {
                position: fixed;
                bottom: 30px;
                right: 30px;
                width: 56px;
                height: 56px;
                border-radius: 50%;
                background: #fff;
                box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
                cursor: pointer;
                z-index: 1000;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.3s ease;
            }
            .ai-copilot-button:hover {
                transform: scale(1.1);
                box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
            }
            .ai-copilot-button.hidden {
                opacity: 0;
                pointer-events: none;
                transform: scale(0.8);
            }
            .ai-copilot-button img {
                width: 36px;
                height: 36px;
            }
            .ai-copilot-sidebar {
                position: fixed;
                top: 0;
                right: -400px;
                width: 400px;
                height: 100vh;
                background: #f9fafb;
                box-shadow: -5px 0 25px rgba(0, 0, 0, 0.15);
                z-index: 1001;
                transition: right 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                display: flex;
                flex-direction: column;
            }
            .ai-copilot-sidebar.open {
                right: 0;
            }
            .ai-copilot-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 16px 20px;
                border-bottom: 1px solid #e5e7eb;
                background: #fff;
                flex-shrink: 0;
            }
            .ai-copilot-header h3 {
                margin: 0;
                font-size: 16px;
                font-weight: 600;
                color: #1f2937;
                display: flex;
                align-items: center;
                gap: 10px;
            }
            .ai-copilot-header h3 img {
                width: 24px;
                height: 24px;
            }
            .ai-copilot-close {
                background: none;
                border: none;
                width: 32px;
                height: 32px;
                border-radius: 6px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: background 0.2s ease;
                color: #6b7280;
            }
            .ai-copilot-close:hover {
                background: #f3f4f6;
                color: #1f2937;
            }
            .ai-copilot-close span {
                font-size: 20px;
                line-height: 1;
            }
            .ai-copilot-header-actions {
                display: flex;
                align-items: center;
                gap: 4px;
            }
            .ai-copilot-new-chat {
                background: #f3f4f6;
                border: 1px solid #e5e7eb;
                padding: 6px 10px;
                border-radius: 6px;
                cursor: pointer;
                display: flex;
                align-items: center;
                gap: 5px;
                transition: all 0.2s ease;
                color: #374151;
                font-size: 12px;
                font-weight: 500;
                margin-right: 8px;
            }
            .ai-copilot-new-chat:hover {
                background: #e5e7eb;
                border-color: #d1d5db;
            }
            .ai-copilot-new-chat svg {
                width: 14px;
                height: 14px;
            }
            .ai-copilot-content {
                flex: 1;
                display: flex;
                flex-direction: column;
                overflow: hidden;
            }
            .ai-copilot-messages {
                flex: 1;
                padding: 20px;
                overflow-y: auto;
            }
            .ai-copilot-welcome {
                text-align: center;
                color: #6b7280;
                padding: 40px 20px;
            }
            .ai-copilot-welcome .ai-lottie-icon {
                width: 60px;
                height: 60px;
                margin: 0 auto 16px;
            }
            .ai-copilot-welcome h4 {
                margin: 0 0 8px;
                color: #374151;
                font-size: 16px;
                font-weight: 600;
            }
            .ai-copilot-welcome p {
                margin: 0;
                font-size: 14px;
                line-height: 1.5;
            }
            .ai-message {
                margin-bottom: 20px;
            }
            .ai-message-question {
                background: #FF6F61;
                color: #fff;
                padding: 10px 14px;
                border-radius: 16px 16px 4px 16px;
                margin-left: 60px;
                margin-bottom: 12px;
                font-size: 14px;
                line-height: 1.5;
            }
            .ai-message-answer {
                background: #fff;
                padding: 14px 16px;
                border-radius: 16px 16px 16px 4px;
                margin-right: 20px;
                font-size: 14px;
                color: #374151;
                line-height: 1.7;
                box-shadow: 0 1px 3px rgba(0,0,0,0.08);
                word-wrap: break-word;
            }
            .ai-typing-indicator {
                display: flex;
                align-items: center;
                gap: 3px;
                padding: 4px 0;
            }
            .ai-typing-indicator span {
                width: 6px;
                height: 6px;
                background: #FF6F61;
                border-radius: 50%;
                animation: bounce 1.4s infinite ease-in-out both;
            }
            .ai-typing-indicator span:nth-child(1) {
                animation-delay: -0.32s;
            }
            .ai-typing-indicator span:nth-child(2) {
                animation-delay: -0.16s;
            }
            .ai-typing-indicator span:nth-child(3) {
                animation-delay: 0s;
            }
            @keyframes bounce {
                0%, 80%, 100% {
                    transform: scale(0.6);
                    opacity: 0.4;
                }
                40% {
                    transform: scale(1);
                    opacity: 1;
                }
            }
            .ai-message-answer strong {
                font-weight: 600;
                color: #1f2937;
            }
            .ai-message-answer code {
                background: #f3f4f6;
                padding: 2px 6px;
                border-radius: 4px;
                font-family: monospace;
                font-size: 13px;
            }
            .ai-message-answer ol, .ai-message-answer ul {
                margin: 10px 0;
                padding-left: 24px;
            }
            .ai-message-answer li {
                margin: 6px 0;
            }
            .ai-message-answer h2, .ai-message-answer h3, .ai-message-answer h4 {
                margin: 12px 0 8px;
                font-weight: 600;
                color: #1f2937;
            }
            .ai-message-answer p {
                margin: 0 0 10px;
            }
            .ai-message-answer p:last-child {
                margin-bottom: 0;
            }
            .ai-inline-img {
                display: block;
                max-width: 100%;
                margin: 12px 0;
                border-radius: 8px;
                border: 1px solid #e5e7eb;
                cursor: pointer;
            }
            .ai-inline-img:hover {
                box-shadow: 0 2px 8px rgba(0,0,0,0.15);
            }
            .ai-image-modal {
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(0,0,0,0.9);
                z-index: 2000;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 20px;
            }
            .ai-image-modal img {
                max-width: 100%;
                max-height: 100%;
                object-fit: contain;
            }
            .ai-image-modal-close {
                position: absolute;
                top: 20px;
                right: 20px;
                color: #fff;
                font-size: 32px;
                cursor: pointer;
                background: none;
                border: none;
            }
            .ai-sources {
                margin-top: 12px;
                padding-top: 12px;
                border-top: 1px solid #e5e7eb;
                font-size: 12px;
                color: #6b7280;
            }
            .ai-sources a {
                color: #FF6F61;
                text-decoration: none;
            }
            .ai-sources a:hover {
                text-decoration: underline;
            }
            .ai-copilot-input {
                padding: 16px 20px;
                background: #fff;
                flex-shrink: 0;
                border-top: 1px solid #e5e7eb;
            }
            .ai-copilot-input-wrapper {
                display: flex;
                gap: 12px;
                align-items: flex-end;
            }
            .ai-copilot-textarea {
                flex: 1;
                resize: none;
                border: 1px solid #e5e7eb;
                border-radius: 12px;
                padding: 12px 16px;
                font-size: 14px;
                font-family: inherit;
                line-height: 1.5;
                min-height: 44px;
                max-height: 120px;
                outline: none;
                transition: border-color 0.2s ease, box-shadow 0.2s ease;
            }
            .ai-copilot-textarea:focus {
                border-color: #FF6F61;
                box-shadow: 0 0 0 3px rgba(255, 111, 97, 0.1);
            }
            .ai-copilot-textarea::placeholder {
                color: #9ca3af;
            }
            .ai-copilot-send {
                width: 44px;
                height: 44px;
                border: none;
                border-radius: 12px;
                background: #FF6F61;
                color: #fff;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.2s ease;
                flex-shrink: 0;
            }
            .ai-copilot-send:hover:not(:disabled) {
                background: #ff5a4a;
                transform: scale(1.05);
            }
            .ai-copilot-send:disabled {
                background: #e5e7eb;
                cursor: not-allowed;
            }
            .ai-copilot-send svg {
                width: 20px;
                height: 20px;
            }
            .ai-copilot-backdrop {
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(0, 0, 0, 0.3);
                z-index: 1000;
                animation: aiFadeIn 0.3s ease;
            }
            @keyframes aiFadeIn {
                from { opacity: 0; }
                to { opacity: 1; }
            }
            @media (max-width: 768px) {
                .ai-copilot-sidebar {
                    width: 100%;
                    right: -100%;
                }
            }
        </style>

        <div ng-if="vm.TokenService.isAssistantModuleEnabled()">
            <!-- Image Modal -->
            <div class="ai-image-modal" ng-if="vm.modalImage" ng-click="vm.closeModal()">
                <button class="ai-image-modal-close">&times;</button>
                <img ng-src="{{ vm.modalImage }}" alt="Screenshot">
            </div>

            <!-- Backdrop -->
            <div class="ai-copilot-backdrop" ng-if="vm.isOpen" ng-click="vm.closeSidebar()"></div>

            <!-- Floating AI Button -->
            <div class="ai-copilot-button" ng-click="vm.toggleSidebar()" ng-class="{ 'hidden': vm.isOpen }">
                <img src="assets/favicons/coursy/favicon-72x72.png" alt="AI">
            </div>

            <!-- AI Sidebar Panel -->
        <div class="ai-copilot-sidebar" ng-class="{ 'open': vm.isOpen }">
            <div class="ai-copilot-header">
                <h3>
                    <img src="assets/favicons/coursy/favicon-72x72.png" alt="">
                    Smart Coursy
                </h3>
                <div class="ai-copilot-header-actions">
                    <button class="ai-copilot-new-chat" ng-click="vm.newChat()" title="{{ 'assistant.New chat' | translate }}">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                        </svg>
                        {{ 'assistant.New' | translate }}
                    </button>
                    <button class="ai-copilot-close" ng-click="vm.closeSidebar()">
                        <span>&times;</span>
                    </button>
                </div>
            </div>
            <div class="ai-copilot-content">
                <div class="ai-copilot-messages" id="aiMessages">
                    <!-- Welcome message -->
                    <div class="ai-copilot-welcome" ng-if="!vm.messages.length">
                        <div class="ai-lottie-icon" id="aiLottieWelcome"></div>
                        <h4>{{ 'assistant.How can I help you' | translate }}</h4>
                        <p>{{ 'assistant.Welcome description' | translate }}</p>
                    </div>

                    <!-- Messages -->
                    <div class="ai-message" ng-repeat="msg in vm.messages">
                        <div class="ai-message-question">{{ msg.question }}</div>
                        <div class="ai-message-answer">
                            <div class="ai-typing-indicator" ng-if="msg.loading">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <span ng-if="!msg.loading" ng-bind-html="vm.renderMarkdown(msg.text)"></span>
                        </div>
                        <div class="ai-sources" ng-if="msg.sources.length" ng-bind-html="vm.renderSources(msg.sources)"></div>
                    </div>
                </div>

                <div class="ai-copilot-input">
                    <div class="ai-copilot-input-wrapper">
                        <textarea
                            class="ai-copilot-textarea"
                            ng-model="vm.question"
                            placeholder="{{ 'assistant.Ask a question' | translate }}"
                            ng-keydown="vm.handleKeydown($event)"
                            rows="1"
                        ></textarea>
                        <button
                            class="ai-copilot-send"
                            ng-click="vm.sendQuestion()"
                            ng-disabled="!vm.question.trim() || vm.isLoading"
                        >
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        </div>
    `
})

export default class {
    constructor ($scope, $timeout, $sce, $translate, TokenService, AssistantResource) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$sce = $sce;
        this.$translate = $translate;
        this.TokenService = TokenService;
        this.AssistantResource = AssistantResource;
        this.isOpen = false;
        this.question = '';
        this.messages = [];
        this.isLoading = false;
        this.modalImage = null;
        this.animationData = animationData;
        this.welcomeAnimation = null;

        // Expose openModal globally for onclick handlers in rendered HTML
        const self = this;
        window.aiOpenModal = (url) => {
            self.$scope.$apply(() => {
                self.modalImage = url;
            });
        };

        // Watch for sidebar open to initialize welcome animation and focus input
        this.$scope.$watch(() => this.isOpen, (isOpen) => {
            if (isOpen) {
                this.$timeout(() => {
                    if (this.messages.length === 0) {
                        this.initWelcomeAnimation();
                    }
                    // Focus the textarea
                    const textarea = document.querySelector('.ai-copilot-textarea');
                    if (textarea) {
                        textarea.focus();
                    }
                }, 100);
            }
        });

        // Watch for messages to destroy welcome animation when chat starts
        this.$scope.$watch(() => this.messages.length, (newLen) => {
            if (newLen > 0 && this.welcomeAnimation) {
                this.welcomeAnimation.destroy();
                this.welcomeAnimation = null;
            }
        });
    }

    initWelcomeAnimation () {
        const container = document.getElementById('aiLottieWelcome');
        if (container && !this.welcomeAnimation) {
            // eslint-disable-next-line
            this.welcomeAnimation = lottie.loadAnimation({
                container,
                renderer: 'svg',
                loop: true,
                autoplay: true,
                animationData: this.animationData,
                rendererSettings: {
                    preserveAspectRatio: 'xMidYMid meet'
                }
            });
        }
    }

    openModal (imageUrl) {
        this.modalImage = imageUrl;
    }

    closeModal () {
        this.modalImage = null;
    }

    renderSources (sources) {
        if (!sources || !sources.length) return '';
        const links = sources.map(s => `<a href="${s.url}" target="_blank">${s.title}</a>`).join(' | ');
        const sourcesLabel = this.$translate.instant('assistant.Sources');
        return this.$sce.trustAsHtml(`${sourcesLabel} ${links}`);
    }

    renderMarkdown (text) {
        if (!text) return '';

        let html = text
            // Escape HTML first
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            // Inline images: [IMG:url] - unescape the URL
            .replace(/\[IMG:(https?:\/\/[^\]]+)\]/g, (_, url) => {
                const cleanUrl = url.replace(/&amp;/g, '&');
                return `<img src="${cleanUrl}" class="ai-inline-img" alt="Screenshot" onclick="window.aiOpenModal && window.aiOpenModal('${cleanUrl}')">`;
            })
            // Bold: **text**
            .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
            // Italic: *text*
            .replace(/\*([^*]+)\*/g, '<em>$1</em>')
            // Code: `text`
            .replace(/`([^`]+)`/g, '<code>$1</code>')
            // Headers: ## text
            .replace(/^### (.+)$/gm, '<h4>$1</h4>')
            .replace(/^## (.+)$/gm, '<h3>$1</h3>')
            .replace(/^# (.+)$/gm, '<h2>$1</h2>')
            // Numbered lists: 1. text
            .replace(/^(\d+)\. (.+)$/gm, '<li>$2</li>')
            // Bullet lists: - text or • text
            .replace(/^[-•] (.+)$/gm, '<li>$1</li>')
            // Wrap consecutive <li> in <ol>
            .replace(/(<li>.*<\/li>\n?)+/g, '<ol>$&</ol>')
            // Line breaks
            .replace(/\n\n/g, '</p><p>')
            .replace(/\n/g, '<br>');

        // Wrap in paragraph
        html = `<p>${html}</p>`;

        // Clean up
        html = html.replace(/<p><\/p>/g, '');
        html = html.replace(/<p>(<h[234]>)/g, '$1');
        html = html.replace(/(<\/h[234]>)<\/p>/g, '$1');
        html = html.replace(/<p>(<ol>)/g, '$1');
        html = html.replace(/(<\/ol>)<\/p>/g, '$1');
        html = html.replace(/<br><img/g, '<img');
        html = html.replace(/><br>/g, '>');

        return this.$sce.trustAsHtml(html);
    }

    toggleSidebar () {
        this.isOpen = !this.isOpen;
    }

    closeSidebar () {
        this.isOpen = false;
    }

    newChat () {
        this.messages = [];
        this.question = '';
        this.isLoading = false;
        this.$timeout(() => {
            this.initWelcomeAnimation();
            const textarea = document.querySelector('.ai-copilot-textarea');
            if (textarea) {
                textarea.focus();
            }
        }, 100);
    }

    handleKeydown (event) {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            this.sendQuestion();
        }
    }

    sendQuestion () {
        if (!this.question.trim() || this.isLoading) {
            return;
        }

        const question = this.question.trim();
        this.question = '';
        this.isLoading = true;

        const message = {
            question,
            text: '',
            sources: [],
            loading: true
        };
        this.messages.push(message);

        this.$timeout(() => {
            this.scrollToBottom();
        });

        this.AssistantResource.help({
            question,
            namespace: 'coursy_docs'
        }).$promise
            .then(response => {
                message.text = response.answer;
                message.sources = response.sources || [];
                message.loading = false;
                this.isLoading = false;
                this.scrollToBottom();
            })
            .catch(error => {
                console.error('Chat error:', error);
                message.text = this.$translate.instant('assistant.Error message');
                message.loading = false;
                this.isLoading = false;
            });
    }

    scrollToBottom () {
        this.$timeout(() => {
            const container = document.getElementById('aiMessages');
            if (container) {
                container.scrollTop = container.scrollHeight;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/sidebar/ai/index.js